import ShowHeaderButtons from 'src/javascripts/components/tables/checkboxes/ShowHeaderButtons';
import UncheckOnClick from 'src/javascripts/components/tables/checkboxes/UncheckOnClick';
import CheckMark from 'src/javascripts/components/tables/checkboxes/CheckMark';

// Uncheck one specific box on clck
export default function(tableId) {

  // Select all displayed checkboxes
  $('#' + tableId + ' tr .checkbox').prop('checked', true);

  // Append a checkmark to all displayed checkboxes
  $('#' + tableId + ' tr .checkbox').closest('td').append(CheckMark());

  // Add to table data of selected records
  $('#' + tableId + ' tbody tr .checkbox').each(function() {
    let recordIds = $('#' + tableId).data('record-ids');
    let recordId = $(this).closest('tr').attr('data-record-id');
    let index = recordIds.indexOf(recordId);
    if (index === -1) {
      $('#' + tableId).data('record-ids').push(recordId);
    }    
  })

  // Show header buttons
  ShowHeaderButtons(tableId);

  // Remove checkbox
  UncheckOnClick(tableId);

}